import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const freeTrialVerifyEmailKey = "/free_trial/verify_email";

export const freeTrialVerifyEmailCacheKeys: AllRouteEndpoints[] = [freeTrialVerifyEmailKey];
